import apiClient from '../services/apiClient';
import { toast } from 'sonner';

export const downloadPayslip = async (slip) => {
  try {
    const url = `/api/payroll/${slip.runId}/export/payslip?employeeId=${slip.empId}`;
    const response = await apiClient.get(url, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Payslip_${slip.name.replace(/\s/g, '_')}_${slip.monthLabel.replace(/\s/g, '-')}.pdf`;
    link.click();
    URL.revokeObjectURL(link.href);
    toast.success('Payslip downloaded');
  } catch (error) {
    toast.error('Failed to download payslip');
  }
};